<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ $t('add_review_site') }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    div.py-6.px-10
      v-card.round-xl.px-4.py-2.mb-4.danger500(v-if="showAlertMessage" dark outlined)
        .text-sm {{ $t('review_select_another_account', { connectionType: 'account' }) }}
      google-business-page-setup(:cols="12" :gmbAccountName="gmbAccountName" @connectOrChange="$emit('connectOrChange')")
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="nextAction" :loading="isLoading" color="neutral700" :disabled="!canProceed" :dark="canProceed" depressed) {{ $t('next') }}
</template>

<script>
import { mapGetters } from 'vuex' 
import GoogleBusinessPageSetup from '@/components/review/settings/GoogleBusinessPageSetup.vue'

export default {
  name: 'ReviewAddSiteDialog',
  components: {
    GoogleBusinessPageSetup,
  },
  props: {
    open: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      reviewAccount: 'review/getMainAccount',
      gmbAccounts: 'review/getGmbAccounts',
      gmbLocations: 'review/getGmbLocations'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed() {
      if (this.reviewAccount && this.reviewAccount.account_id && this.reviewAccount.account_name) {
        return true
      }
      return false
    },
    gmbAccountName() {
      if (this.canProceed) {
        return this.reviewAccount.account_name
      }
      return null
    },
    showAlertMessage() {
      return this.reviewAccount && this.gmbAccounts.length === 0
    },
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    nextAction() {
      this.isLoading = true
      this.$emit('next')
    }
  },
}
</script>